import { render, staticRenderFns } from "./ChartWrapper.vue?vue&type=template&id=247795ac&scoped=true&"
import script from "./ChartWrapper.vue?vue&type=script&lang=js&"
export * from "./ChartWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ChartWrapper.vue?vue&type=style&index=0&id=247795ac&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247795ac",
  null
  
)

export default component.exports